import { IsAuthenticatedContext, passLastUpdatedContext } from "auth";
import { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

/**
 * Higher-order component that accepts an auth object. If the user is authenticated, allows the
 * route to execute as normal. If the user is not authenticated, redirects the user to the `/login`
 * route
 */
export const PrivateRoute: React.FC | any | null = () => {
  const [isAuthenticated, _] = useContext(IsAuthenticatedContext);
  const [passwordLastUpdated, __] = useContext(passLastUpdatedContext);
  const navigate = useNavigate();
  const location = useLocation();
  const loggedIn  = localStorage.getItem("isLoggedIn") === "true";
  const passValid = localStorage.getItem("passValid")

  useEffect(() => {
    const sessionExpiryTime = localStorage.getItem("sessionExpiryTime");
    if (sessionExpiryTime && Date.now() > parseInt(sessionExpiryTime)) {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("username");
      localStorage.setItem("logout", Date.now().toString());
      window.location.href = "/login";
    }
    if (!loggedIn) {
      navigate("/login", {
        replace: true,
        state: { from: location.pathname, search: location.search },
      });
    } else if (isAuthenticated && passValid==="false"?true:false) {
      navigate("/settings", {
        state: {
          from: location.pathname,
          search: location.search,
        },
      });
    }
  },[loggedIn, passValid, navigate, location]);

  return loggedIn && isAuthenticated
    ? <Outlet />
    : <Navigate to="/login" replace />;
};
